import axios from 'axios';

const Api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

// - agenda Lucas - (opcional, não muda estrutura)
// garante token em qualquer request mesmo se alguém esquecer de setar defaults
Api.interceptors.request.use((config) => {
    // ✅ Fallback: tenta sessionStorage (novo padrão), se não achar tenta localStorage (legado/persistente)
    const token = sessionStorage.getItem('@ScheduleNogleApp:token') || localStorage.getItem('@ScheduleNogleApp:token');

    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const exceptionNotificationAPI = (error, toast) => {
    if (/500/.test(error.message)) {
        console.error('Failed to connect Web Service (500).');
    } else if (/404/.test(error.message)) {
        console.error('Route Not Found (404).');
    } else if (/401/.test(error.message)) {
        sessionStorage.clear();
        localStorage.removeItem('@ScheduleNogleApp:token');
        localStorage.removeItem('@ScheduleNogleApp:user');
        localStorage.removeItem('@ScheduleNogleApp:userName');

        window.location.href = "/";
    } else if (/400/.test(error.message)) {
        let notifications = error.response.data.errors;
        if (notifications && notifications.length > 0) {
            notifications.forEach((not) => {
                console.log(not);
            })
        }
    } else {
        console.error(error.message);
    }
}

export default Api;
